import { API_BROADCASTER } from "../api/broadcasters";

export const getBroadcasterByPathname = async () => {
  const name = decodeURIComponent(window.location.pathname.split("chat/")[1]);
  const filter = +name ? { broadcaster_id: +name } : { nickname: name };
  const resBroadcaster = await API_BROADCASTER.list({ filter: filter });
  const newBroadcaster = API_BROADCASTER.utils.getModals(resBroadcaster)?.[0];
  return newBroadcaster;
};

export const getBroadcasterById = async (id) => {
  const resBroadcaster = await API_BROADCASTER.list({ filter: { broadcaster_id: id } });
  const newBroadcaster = API_BROADCASTER.utils.getModals(resBroadcaster)?.[0];
  return newBroadcaster;
};
